export default __webpack_public_path__ + "static/media/BOT.a7bac88f.svg";